'use client';

import { type RoadMapUpdate } from '@/domain/roadmap/types';
import { TextField } from '@andritzot/metris-web-ui/inputs/textfield';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';

import { FieldActionsWrapper } from './shared/FieldActionsWrapper';

interface KeyFieldProps {
  roadmap: RoadMapUpdate;
}

export function KeyField({ roadmap }: Readonly<KeyFieldProps>) {
  if (!roadmap.idRoadmap) return null;

  const keyValue = `SF-${roadmap.idRoadmap}`;
  return (
    <Box sx={{ py:0.75 ,width: '100%' }}>
      <FieldActionsWrapper copyValue={keyValue}>
        <TextField label="Item Key" required disabled={true} fullWidth size="small" value={keyValue} />
      </FieldActionsWrapper>
    </Box>
  );
}
